export default "__VITE_ASSET__aabc091e__"